<h2 mat-dialog-title>{{ title }}</h2>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ cancelText }}</button>
  <button mat-flat-button [color]="confirmColor" (click)="confirm()">
    {{ confirmText }}
  </button>
</div>
